import React from "react";

export interface DimensionModel {
    width: number;
    height: number;
    innerWidth: number;
    innerHeight: number;

    minWidth(minWidth: number): boolean;
    maxWidth(maxWidth: number): boolean;
}

export default function useWindowDimensions() {
    const [{ width, height, innerWidth, innerHeight }, setDimensions] = React.useState<
        Partial<DimensionModel>
    >({ width: 0, height: 0, innerWidth: 0, innerHeight: 0 });

    React.useEffect(() => {
        function calcDimensions() {
            setDimensions({
                width: window.outerWidth,
                height: window.outerHeight,
                innerWidth: window.innerWidth,
                innerHeight: window.innerHeight,
            });
        }

        window.addEventListener("resize", calcDimensions);
        calcDimensions();

        return () => {
            window.removeEventListener("resize", calcDimensions);
        };
    }, []);

    return React.useMemo<DimensionModel>(
        () => ({
            width,
            height,
            innerWidth,
            innerHeight,
            minWidth: (min) => width >= min,
            maxWidth: (max) => width < max,
        }),
        [height, innerHeight, innerWidth, width],
    );
}
